<div id="manutencao-envio-cte" class="container-fluid">
  <h3>Manutenção de Envio de CTE</h3>
  <mat-card id="filters">
    <mat-card-header class="header-padrao">
      <mat-card-title>
        <form class="d-flex align-items-center filtros-header" [formGroup]="filterForm">

          <mat-form-field>
            <mat-select
              formControlName="clienteSelecionado"
              disableOptionCentering="true"
              placeholder="Cliente"
            >
              <mat-option><ngx-mat-select-search [formControl]="clienteMultiFilter" placeholderLabel="Buscar..."
              noEntriesFoundLabel="Nenhum resultado encontrado..."></ngx-mat-select-search></mat-option>
              <mat-option
                *ngFor="let cliente of filteredClientes | async"
                [value]="cliente?.id"
              >
                {{ cliente?.nome }}
              </mat-option>
            </mat-select>
          </mat-form-field>

          <mat-form-field>
            <mat-label>Descrição:</mat-label>
            <input matInput placeholder="Descrição envio CTE" formControlName="descricaoEnvioCte" />
          </mat-form-field>

          <mat-form-field>
            <mat-label>Tipo de Envio:</mat-label>
            <mat-select formControlName="tipoEnvioSelecionado">
              <mat-option *ngFor="let r of opcaoEnvios" [value]="r.tipoEnvio">
                {{ r.descricao }}
              </mat-option>
            </mat-select>
          </mat-form-field>

          <mat-form-field>
            <mat-label>Status:</mat-label>
            <mat-select formControlName="statusSelecionado">
              <mat-option *ngFor="let r of opcaoStatus" [value]="r.status">
                {{ r.descricao }}
              </mat-option>
            </mat-select>
          </mat-form-field>

          <mat-form-field matTooltip="Pesquise pelas configurações de envio como por exemplo o endereço de e-mail de destino ou dados do FTP">
            <mat-label>Valor do Parâmetro:</mat-label>
            <input matInput placeholder="Valor do Parâmetro" formControlName="valorParametro" />
          </mat-form-field>

          <button mat-icon-button (click)="clearFields()" matTooltip="Limpar Campos">
            <i class="fas fa-eraser eraser-button"></i>
          </button>

          <button mat-icon-button [disabled]="filterForm.invalid" (click)="paging.index = 0; getGridEnviosCte()">
            <i class="fas fa-search search-button cursor-pointer-icon" matTooltip="Pesquisar"></i>
          </button>
          <button class="float-right" mat-flat-button color="primary" (click)="modalNovoEnvioCte(null)">
            Nova Configuração <i class="fas fa-plus" style="font-size: 12px"></i>
          </button>
        </form>
      </mat-card-title>
    </mat-card-header>
    <mat-progress-bar color="primary" mode="indeterminate" [hidden]="!isLoading"></mat-progress-bar>
    <mat-card-content class="no-padding" [hidden]="!exibirGrid">
      <div [hidden]="isLoading || gridEnviosCte?.data?.length === 0">
        <div>
          <table id="relatorios" mat-table [dataSource]="gridEnviosCte" class="table-sm">

            <ng-container matColumnDef="action">
              <th mat-header-cell *matHeaderCellDef>Ações</th>
              <td mat-cell *matCellDef="let gridEnviosCte" width="90px">
                <button mat-icon-button [matMenuTriggerFor]="menu" aria-label="Example icon-button with a menu">
                  <mat-icon>more_vert</mat-icon>
                </button>
                <mat-menu #menu="matMenu">
                  <button mat-menu-item color="primary" (click)="modalNovoEnvioCte(gridEnviosCte.codigo)">
                    <mat-icon fontSet="fas" fontIcon="fa-edit"></mat-icon>
                    <span>Editar</span>
                  </button>
                  <!-- <button mat-menu-item color="primary" (click)="modalNovoEnvioCte(gridEnviosCte.envioCteID)">
                    <mat-icon fontSet="fas" fontIcon="fa-copy"></mat-icon>
                    <span>Criar uma cópia</span>
                  </button> -->
                </mat-menu>
              </td>
            </ng-container>

            <ng-container matColumnDef="codigo">
              <th mat-header-cell *matHeaderCellDef>Código</th>
              <td mat-cell *matCellDef="let gridEnviosCte">
                {{ gridEnviosCte.codigo }}
              </td>
            </ng-container>

            <ng-container matColumnDef="descricao">
              <th mat-header-cell *matHeaderCellDef>Descrição</th>
              <td mat-cell *matCellDef="let gridEnviosCte">
                {{ gridEnviosCte.descricao }}
              </td>
            </ng-container>

            <ng-container matColumnDef="tipoEnvio">
              <th mat-header-cell *matHeaderCellDef>Tipo Envio</th>
              <td mat-cell *matCellDef="let gridEnviosCte">
                {{ gridEnviosCte.tipoEnvio }}
              </td>
            </ng-container>

            <ng-container matColumnDef="delayEnvio">
              <th mat-header-cell *matHeaderCellDef>Atraso no envio</th>
              <td mat-cell *matCellDef="let gridEnviosCte">
                {{ gridEnviosCte.delayEnvio === '1 Horas' ? '1 Hora' : gridEnviosCte.delayEnvio }}
              </td>
            </ng-container>

            <ng-container matColumnDef="status">
              <th mat-header-cell *matHeaderCellDef>Status</th>
              <td mat-cell *matCellDef="let gridEnviosCte">
                {{ gridEnviosCte.status }}
              </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
          </table>
        </div>
        <app-paginacao [pageIndex]="paging?.index" [pageSize]="paging?.size" [length]="paging?.length"
          (page)="onPageChange($event)" [pageSizeOptions]="[10, 20, 50]"></app-paginacao>
        <div class="text-right p-1">
          <button mat-flat-button type="button" color="success" (click)="downloadExcel()"
            [disabled]="isLoadingDownload">
            <span *ngIf="isLoadingDownload" class="d-flex align-items-center">
              <mat-spinner diameter="20" color="dark"></mat-spinner>
              &nbsp; Baixando
            </span>
            <span *ngIf="!isLoadingDownload">
              <i class="fas fa-file-excel"></i> Download Excel
            </span>
          </button>
        </div>
      </div>
      <div *ngIf="!isLoading && gridEnviosCte?.data?.length === 0"
        class="d-flex justify-content-center align-items-center" style="height: 100px">
        Nenhum envio de CTE encontrado!
      </div>
    </mat-card-content>
  </mat-card>
</div>
